import React, { useId } from 'react';

/**
 * Interruptor — liga e desliga (role="switch", aria-checked).
 * Com `linha`, mostra título e texto de apoio ao lado, como nas Preferências.
 */
export default function Interruptor({ ligado, onChange, rotulo, linha = false, titulo, texto, disabled = false }) {
  const gerado = useId();
  const tituloId = `${gerado}-titulo`;
  const botao = (
    <button
      type="button"
      role="switch"
      className="sj-interruptor"
      aria-checked={Boolean(ligado)}
      aria-label={linha ? undefined : rotulo}
      aria-labelledby={linha ? tituloId : undefined}
      disabled={disabled}
      onClick={() => onChange?.(!ligado)}
    />
  );

  if (!linha) return botao;

  return (
    <div className="sj-interruptor-linha">
      <div>
        <div id={tituloId} className="sj-interruptor-linha__titulo">{titulo}</div>
        {texto && <div className="sj-interruptor-linha__texto">{texto}</div>}
      </div>
      {botao}
    </div>
  );
}
